import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AnonymousAuthGuard } from '@shared/guards/anonymous-auth.guard';
import { LoginLayoutComponent } from './core/layout/login-layout/login-layout.component';
import { HomeLayoutComponent } from './core/layout/home-layout/home-layout.component';
import { LoginComponent } from './core/pages/public/login/login.component';
import { RegistrationComponent } from './core/pages/public/registration/registration.component';
import { WebSiteComponent } from './core/pages/public/web-site/web-site.component';
import { PageUnderContructionComponent } from '@shared/components/page-under-contruction/page-under-contruction.component';
import { PortfolioComponent } from './core/pages/portfolio/portfolio.component';
import { RewardsComponent } from './core/pages/rewards/rewards.component';
import { TierComponent } from './core/pages/rewards/tier/tier.component';
import { ProfileComponent } from './core/pages/profile/profile.component';
import { CartComponent } from './core/pages/cart/cart.component';
import { InvestementConfirmedComponent } from './core/pages/cart/investement-confirmed/investement-confirmed.component';
import { PaymentComponent } from './core/pages/cart/payment/payment.component';
import { BookmarkedComponent } from './core/pages/properties/bookmarked/bookmarked.component';
import { PhotosGalleryComponent } from './core/pages/properties/photos-gallery/photos-gallery.component';
import { PropertiesComponent } from './core/pages/properties/properties.component';
import { PropertyViewComponent } from './core/pages/properties/property-view/property-view.component';
import { DepositComponent } from './core/pages/wallet/deposit/deposit.component';
import { WalletComponent } from './core/pages/wallet/wallet.component';
import { WithdrawComponent } from './core/pages/wallet/withdraw/withdraw.component';
import { PropertyManagementComponent } from './core/pages/property-management/property-management.component';
import { BankAccountDepositComponent } from './core/pages/wallet/bank-account-deposit/bank-account-deposit.component';

const anonymousRoutes: Routes = [
  {
    path: 'properties',
    component: PropertiesComponent,
    title: 'Properties | Seedio',
  },
  {
    path: 'properties/view/:id',
    component: PropertyViewComponent,
    title: 'Property | Seedio',
  },
  {
    path: 'properties/view/:id/photos',
    component: PhotosGalleryComponent,
    title: 'Photos | Property | Seedio',
  },
].map((route) => ({ ...route, canActivate: [AnonymousAuthGuard] }));

const protectedRoutes: Routes = [
  {
    path: 'wallet',
    component: WalletComponent,
    title: 'Wallet | Seedio',
  },
  {
    path: 'wallet/bank-deposit',
    component: BankAccountDepositComponent,
    title: 'Bank Deposit | Wallet | Seedio',
  },
  // Use those router later
  // {
  //   path: 'wallet/deposit',
  //   component: DepositComponent,
  //   title: 'Deposit | Wallet | Seedio',
  // },
  // {
  //   path: 'wallet/withdraw',
  //   component: WithdrawComponent,
  //   title: 'Withdraw | Wallet | Seedio',
  // },
  {
    path: 'portfolio',
    component: PortfolioComponent,
    title: 'Portfolio | Seedio',
  },
  {
    path: 'rewards',
    component: RewardsComponent,
    title: 'Rewards | Seedio',
  },
  {
    path: 'rewards/tier',
    component: TierComponent,
    title: 'Tier | Rewards | Seedio',
  },
  {
    path: 'cart',
    component: CartComponent,
    title: 'Cart | Seedio',
  },
  {
    path: 'cart/payment',
    component: PaymentComponent,
    title: 'Payment | Cart | Seedio',
  },
  {
    path: 'cart/payment/investment-confirmed',
    component: InvestementConfirmedComponent,
    title: 'Investment Confirmed | Cart | Seedio',
  },
  {
    path: 'profile',
    component: ProfileComponent,
    title: 'Profile | Seedio',
  },
  {
    path: 'properties/bookmarked',
    component: BookmarkedComponent,
    title: 'Bookmarks | Properties | Seedio',
  },
  {
    path: 'property-management',
    component: PropertyManagementComponent,
    title: 'Property management | Seedio',
  },
].map((route) => ({ ...route, canActivate: [AuthGuard] }));

export const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    title: 'Seedio',
    children: [
      { path: '', redirectTo: '/home/properties', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      {
        path: 'registration',
        component: RegistrationComponent,
        title: 'Registration | Seedio',
      },
      {
        path: 'forgot-password',
        component: PageUnderContructionComponent,
        title: 'Forgot password | Seedio',
      },
    ],
  },
  {
    path: 'home',
    component: HomeLayoutComponent,
    title: 'Seedio',
    children: [
      { path: '', redirectTo: 'properties', pathMatch: 'full' },
      ...anonymousRoutes,
      ...protectedRoutes,
    ],
  },
  { path: '**', redirectTo: 'home/properties' },
];
